import type { ReactNode } from "react";
import { PALETTE_LABELS, type PaletteName } from "../main/Renderer";

export function GameControls({ palette, volume, touch, showKeys, powerDisabled, onPower, onPalette, onVolume, onKeys, onTouch, children }: {
  palette: PaletteName; volume: number; touch: boolean; showKeys: boolean; powerDisabled: boolean;
  onPower(): void; onPalette(p: PaletteName): void; onVolume(v: number): void; onKeys(): void; onTouch(): void; children?: ReactNode;
}) {
  return <section className="forest-game-controls" aria-label="Game controls">
    <h3>Game controls</h3>
    <button aria-expanded={showKeys} onClick={onKeys}>Controls</button>
    <button aria-pressed={touch} onClick={onTouch}>{touch ? "Hide" : "Show"} touch pad</button>
    <label className="forest-control-label">Audio<input aria-label="Volume" type="range" min={0} max={1} step={0.05} defaultValue={volume} onChange={e => onVolume(Number(e.target.value))} /></label>
    <label className="forest-control-label">Colour<select aria-label="Palette" value={palette} onChange={e => onPalette(e.target.value as PaletteName)}>
      {(Object.keys(PALETTE_LABELS) as PaletteName[]).map(p => <option key={p} value={p}>{PALETTE_LABELS[p]}</option>)}
    </select></label>
    <button className="forest-power" disabled={powerDisabled} onClick={onPower}>Power cycle</button>
    {children}
  </section>;
}

export function FullscreenButton({ onClick }: { onClick(): void }) {
  return <button className="forest-fullscreen" aria-label="Toggle fullscreen" title="Fullscreen" onKeyDown={e => e.stopPropagation()} onClick={onClick}>
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M8 3H3v5M16 3h5v5M21 16v5h-5M8 21H3v-5"/></svg>
  </button>;
}
